import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=6a96f34f&scoped=true"
import script from "./page6.vue?vue&type=script&lang=js"
export * from "./page6.vue?vue&type=script&lang=js"
import style0 from "./page6.vue?vue&type=style&index=0&id=6a96f34f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96f34f",
  null
  
)

export default component.exports